export const download = () => (
  <path
    d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4m4-5l5 5m0 0l5-5m-5 5V3"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
